import { render, staticRenderFns } from "./checkDrawer.vue?vue&type=template&id=71e6a347&scoped=true"
import script from "./checkDrawer.vue?vue&type=script&lang=js"
export * from "./checkDrawer.vue?vue&type=script&lang=js"
import style0 from "./checkDrawer.vue?vue&type=style&index=0&id=71e6a347&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e6a347",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e6a347')) {
      api.createRecord('71e6a347', component.options)
    } else {
      api.reload('71e6a347', component.options)
    }
    module.hot.accept("./checkDrawer.vue?vue&type=template&id=71e6a347&scoped=true", function () {
      api.rerender('71e6a347', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/module/components/checkDrawer.vue"
export default component.exports